import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { Bar, Column, Line, Pie } from "@ant-design/plots";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const FarmerTotalHarvestSummaryReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "") return "0";

    const number = Number(num);

    if (isNaN(number)) return num;

    return number.toLocaleString("en-US");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonData, setSeasondata] = useState([]);
  const [ranchData, setRanchdata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);

  const [seasonId, setSeasonId] = useState();
  const [ranchId, setRanchId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);

  const plotItems = data?.byPlot?.rows || [];
  const dateItems = data?.byDate?.rows || [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = plotItems.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRanchWeighBridgeFarmerData } = useHttp();

  const fillRanchWeighBridgeFarmerData = (getType = "") => {
    var urlfilter = "";

    if (seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
    if (ranchId > 0) urlfilter += `&ranchId=${ranchId}`;
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNumber != "") urlfilter += `&farmerNo=${farmerNumber}`;

    var url = `/api/totalHarvestSummaryReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getRanchWeighBridgeFarmerData({ url: url }, (data) => {
      setData(data?.data);
    });
  };

  useEffect(() => {
    fillRanchWeighBridgeFarmerData(0, 0, "");
  }, [getRanchWeighBridgeFarmerData]);

  const handleExport = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const workbook = XLSX.utils.book_new();
    const sheetData = [];

    sheetData.push(["BY PLOT SUMMARY"]);
    sheetData.push(["Label", ...data.byPlot.columns]);

    data.byPlot.rows.forEach((row) => {
      const rowData = [
        row.label,
        ...data.byPlot.columns.map((col) => row[col]),
      ];
      sheetData.push(rowData);
    });

    // Add a blank row as separator
    sheetData.push([]);

    sheetData.push(["BY DATE SUMMARY"]);
    sheetData.push(["Label", ...data.byDate.columns]);

    data.byDate.rows.forEach((row) => {
      const rowData = [
        row.label,
        ...data.byDate.columns.map((col) => row[col]),
      ];
      sheetData.push(rowData);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Harvest Summary");

    XLSX.writeFile(workbook, "FarmerTotalHarvestSummary.xlsx");
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);


  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getRanchData } = useHttp();
  useEffect(() => {
    getRanchData(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchdata(data);
      }
    );
  }, [getRanchData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/harvestFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  const excelDownload = async (employeeId, farmerNo, getType = "") => {
    setLoading(true);

    var urlfilter = "";
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNo != "") urlfilter += `&farmerNo=${farmerNo}`;
    if (getType != "") urlfilter += `&getType=${getType}`;

    var url = `${process.env.REACT_APP_BASE_URL
      }/api/RanchWeighbridgeFarmerReport/?orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "farmerEnrollmentReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">
              Harvest Dashboard
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* Season Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      setSeasonId(e.target.value || 0);
                      EmployeeDetail(e.target.value || 0);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Ranch Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch Name</label>
                  <select
                    id="RanchId"
                    className="form-control"
                    ref={(el) => (frmRef.current["RanchId"] = el)}
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value);
                      EmployeeDetail(e.target.value);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Procurement Officer */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}

              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillRanchWeighBridgeFarmerData(
                        employeeId,
                        seasonId,
                        farmerNumber
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-success mx-2"
                onClick={handleExport}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="col-12">
                      <div
                        className="card "
                        title="Good and Bad Quantity by Plots"
                      >
                        <div className="card-header bg-info text-white fw-bold">
                          Good and Bad Quantity by Plots
                        </div>
                        <div
                          className="card-body"
                          style={{ height: 400, marginBottom: 30 }}
                        >
                          {data.byPlot &&
                            data.byPlot.rows &&
                            data.byPlot.rows.length > 0 ? (
                            <Column
                              data={data.byPlot.rows
                                .filter(
                                  (row) =>
                                    row.label === "Good" || row.label === "Bad"
                                )
                                .flatMap((row) =>
                                  data.byPlot.columns.map((plot) => ({
                                    plot,
                                    type: row.label,
                                    value: Number(row[plot]) || 0,
                                  }))
                                )}
                              isGroup={true}
                              xField="plot"
                              yField="value"
                              seriesField="type"
                              color={({ type }) =>
                                type === "Good" ? "#50C2E5" : "#f8871eff"
                              }
                              label={false}
                              // label={{
                              //   position: "top",
                              //   formatter: (datum) =>
                              //     datum.value.toLocaleString(),
                              //   style: { fontWeight: 200, fill: "#000" },
                              // }}
                              xAxis={{
                                title: { text: "Plots" },
                              }}
                              yAxis={{
                                title: { text: "Quantity (Kg)" },
                                min: 0,
                              }}
                              legend={{
                                position: "top-left",
                              }}
                              tooltip={{
                                showTitle: true,
                              }}
                              columnStyle={{
                                radius: [4, 4, 0, 0],
                              }}
                              columnWidthRatio={0.2}
                            />
                          ) : (
                            <div className="text-center">No data available</div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* By Plot Table */}
                    <div className="card " title="Table By Plot Summary">
                      <div className="card-header bg-info text-white fw-bold">
                        Table By Plot Summary
                      </div>
                      <div
                        className="card-body"
                        style={{ backgroundColor: "#cce7efff" }}
                      >
                        {data?.byPlot && (
                          <section className="content">
                            <div className="container-fluid">
                              <div className="card">
                                <div
                                  className="card-body"
                                  style={{
                                    padding: "0.4rem",
                                    marginTop: "-25px",
                                  }}
                                >
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered text-center table-sm"
                                      style={{ width: "100%" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th>Plot Name</th>
                                          {data.byPlot.columns.map(
                                            (col, idx) => (
                                              <th key={idx}>{col}</th>
                                            )
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {plotItems.map((row, idx) => (
                                          <tr key={idx}>
                                            <td>
                                              <strong>{row.label}</strong>
                                            </td>
                                            {data.byPlot.columns.map(
                                              (col, j) => (
                                                <td
                                                  key={j}
                                                  style={{ textAlign: "right" }}
                                                >
                                                  {row[col] !== undefined && row[col] !== null
                                                    ? formatNumber(row[col])
                                                    : "-"}

                                                </td>
                                              )
                                            )}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        )}
                      </div>
                    </div>

                    {/* By Date Table */}
                    <div className="card" title="Table By Date Summary">
                      <div className="card-header bg-info text-white fw-bold">
                        Table By Date Summary
                      </div>
                      <div
                        className="card-body"
                        style={{ backgroundColor: "#cce7efff" }}
                      >
                        {data?.byDate && (
                          <section className="content mt-5">
                            <div className="container-fluid">
                              <div className="card">
                                <div
                                  className="card-body"
                                  style={{
                                    padding: "0.4rem",
                                    marginTop: "-25px",
                                  }}
                                >
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered text-center table-sm"
                                      style={{ width: "100%" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th style={{ width: "150px" }}>
                                            Date
                                          </th>
                                          {data.byDate.columns.map(
                                            (col, idx) => (
                                              <th
                                                key={idx}
                                                style={{ width: "100px" }}
                                              >
                                                {col}
                                              </th>
                                            )
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {data.byDate.rows
                                          .filter(
                                            (row) => row.label !== "Harvest No"
                                          )
                                          .map((row, rowIdx) => (
                                            <tr key={rowIdx}>
                                              <td>
                                                <strong>{row.label}</strong>
                                              </td>
                                              {data.byDate.columns.map(
                                                (col, colIdx) => {
                                                  let value = row[col];

                                                  // Try formatting if numeric
                                                  let numVal = Number(
                                                    String(value).replace(
                                                      /[^\d.-]/g,
                                                      ""
                                                    )
                                                  );

                                                  if (
                                                    !isNaN(numVal) &&
                                                    !String(value).includes("%")
                                                  ) {
                                                    if (
                                                      String(value)
                                                        .toLowerCase()
                                                        .includes("kg")
                                                    ) {
                                                      value = `${numVal.toLocaleString(
                                                        "en-US",
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }
                                                      )} kg`;
                                                    } else {
                                                      value =
                                                        numVal.toLocaleString(
                                                          "en-US",
                                                          {
                                                            maximumFractionDigits: 2,
                                                          }
                                                        );
                                                    }
                                                  }

                                                  return (
                                                    <td key={colIdx}>
                                                      {value}
                                                    </td>
                                                  );
                                                }
                                              )}
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerTotalHarvestSummaryReport;
